// ===== IMPORTS ==========================
// The import syntax below is Slate specific and tells Gulp, or whatever build tools Slate V0 runs behind the hood, to concat the listed files into this one.

// SIZE-GUIDE
elementReady('#skt-fields').then(function () {
  $('<label class="variant__label" for="sktcgc_to">Recipient Name</label>').insertBefore('#sktcgc_to');
  $('<label class="variant__label" for="sktcgc_from">Sender Name</label>').insertBefore('#sktcgc_from');
  $('<label class="variant__label" for="sktcgc_msg">Gift Message</label>').insertBefore('#sktcgc_msg');

  $('#sktcgc_to').attr('placeholder', 'Recipient Name');
  $('#sktcgc_from').attr('placeholder', 'Sender Name');
  $('#sktcgc_msg').attr('placeholder', 'Gift Message');
});